/** Телефон в вид «+7 903 517 09 42» — как в макете кабинета.

    На вход годится и E.164 из Keycloak, и что угодно с лишними знаками: берутся
    цифры. Не 11 цифр — возвращается как пришло: угадывать чужой формат хуже, чем
    показать его как есть. */
export function phoneView(raw: string): string {
    const d = raw.replace(/\D/g, '');
    if (d.length !== 11) return raw;
    const n = d[0] === '8' ? '7' + d.slice(1) : d;
    return `+${n[0]} ${n.slice(1, 4)} ${n.slice(4, 7)} ${n.slice(7, 9)} ${n.slice(9, 11)}`;
}

const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const MONTHS_FULL = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];
const DOW = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];

/** «16» и «дек» для плашки дня — как в макете. */
export function dayCell(iso: string): { day: string; month: string } {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return { day: '—', month: '' };
    return { day: String(d.getDate()).padStart(2, '0'), month: MONTHS_SHORT[d.getMonth()] };
}

/** «9 декабря» — для подписи под названием. */
export function dateLong(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getDate()} ${MONTHS_FULL[d.getMonth()]}`;
}

/** «9 декабря, 14:00» — момент процедуры, от которого считается весь план.
 *
 *  Время печатается в зоне БРАУЗЕРА, и другого выбора нет: зоны клиники на
 *  проводе не существует, `anchorAt` приезжает инстантом. Для пациента, который
 *  лечится там же, где живёт, это и есть верное время; расхождение возможно
 *  только у человека, уехавшего в другой часовой пояс. */
export function dateTimeLong(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${d.getDate()} ${MONTHS_FULL[d.getMonth()]}, ${hh}:${mm}`;
}

/** «вторник» — день недели строкой. */
export function weekday(iso: string): string {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '' : DOW[d.getDay()];
}

/** Инициалы для «жемчужины»: «Мария Котова» → «МК».

    Из ФИО берутся ПЕРВЫЕ ДВА слова, а не первое и последнее: в базе имя лежит
    как «Имя Отчество Фамилия», и последнее слово — фамилия только когда отчества
    нет. Пусто — жемчужина без букв, это законно. */
export function initials(full: string): string {
    return full
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');
}
